/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Sortby_Pcreleasedate3Inputs */

const id_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal Rilis PC`)
};

const ms_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh Keluaran PC`)
};

const da_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC Udgivelsesdato`)
};

const de_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC-Veröffentlichungsdatum`)
};

const en_us2_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC Release Date`)
};

const es_es2_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de lanzamiento en PC`)
};

const es_mx2_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de lanzamiento en PC`)
};

const fil_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petsa ng PC Release`)
};

const fr_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de sortie PC`)
};

const it_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data uscita PC`)
};

const hu_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC megjelenés dátuma`)
};

const nl_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pc-releasedatum`)
};

const no_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC-utgivelsesdato`)
};

const pl_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data premiery na PC`)
};

const pt_br2_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de lançamento para PC`)
};

const pt_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de lançamento no PC`)
};

const ro_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data lansării pe PC`)
};

const fi_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC-julkaisupäivä`)
};

const sv_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC-releasedatum`)
};

const vi_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày phát hành PC`)
};

const tr_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC Çıkış Tarihi`)
};

const cs_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum vydání na PC`)
};

const bg_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата на издаване за PC`)
};

const ru_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата выхода на ПК`)
};

const uk_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата виходу на ПК`)
};

const ar_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ إصدار PC`)
};

const hi_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC रिलीज़ तारीख़`)
};

const th_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันที่วางจำหน่าย PC`)
};

const ja_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC リリース日`)
};

const zh_cn2_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC发布日期`)
};

const zh_hant1_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC發布日期`)
};

const ko_tags_sortby_pcreleasedate3 = /** @type {(inputs: Tags_Sortby_Pcreleasedate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC 출시일`)
};

/**
* | output |
* | --- |
* | "PC Release Date" |
*
* @param {Tags_Sortby_Pcreleasedate3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const tags_sortby_pcreleasedate3 = /** @type {((inputs?: Tags_Sortby_Pcreleasedate3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Sortby_Pcreleasedate3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tags_sortby_pcreleasedate3(inputs)
	if (locale === "ms") return ms_tags_sortby_pcreleasedate3(inputs)
	if (locale === "da") return da_tags_sortby_pcreleasedate3(inputs)
	if (locale === "de") return de_tags_sortby_pcreleasedate3(inputs)
	if (locale === "en-US") return en_us2_tags_sortby_pcreleasedate3(inputs)
	if (locale === "es-ES") return es_es2_tags_sortby_pcreleasedate3(inputs)
	if (locale === "es-MX") return es_mx2_tags_sortby_pcreleasedate3(inputs)
	if (locale === "fil") return fil_tags_sortby_pcreleasedate3(inputs)
	if (locale === "fr") return fr_tags_sortby_pcreleasedate3(inputs)
	if (locale === "it") return it_tags_sortby_pcreleasedate3(inputs)
	if (locale === "hu") return hu_tags_sortby_pcreleasedate3(inputs)
	if (locale === "nl") return nl_tags_sortby_pcreleasedate3(inputs)
	if (locale === "no") return no_tags_sortby_pcreleasedate3(inputs)
	if (locale === "pl") return pl_tags_sortby_pcreleasedate3(inputs)
	if (locale === "pt-BR") return pt_br2_tags_sortby_pcreleasedate3(inputs)
	if (locale === "pt") return pt_tags_sortby_pcreleasedate3(inputs)
	if (locale === "ro") return ro_tags_sortby_pcreleasedate3(inputs)
	if (locale === "fi") return fi_tags_sortby_pcreleasedate3(inputs)
	if (locale === "sv") return sv_tags_sortby_pcreleasedate3(inputs)
	if (locale === "vi") return vi_tags_sortby_pcreleasedate3(inputs)
	if (locale === "tr") return tr_tags_sortby_pcreleasedate3(inputs)
	if (locale === "cs") return cs_tags_sortby_pcreleasedate3(inputs)
	if (locale === "bg") return bg_tags_sortby_pcreleasedate3(inputs)
	if (locale === "ru") return ru_tags_sortby_pcreleasedate3(inputs)
	if (locale === "uk") return uk_tags_sortby_pcreleasedate3(inputs)
	if (locale === "ar") return ar_tags_sortby_pcreleasedate3(inputs)
	if (locale === "hi") return hi_tags_sortby_pcreleasedate3(inputs)
	if (locale === "th") return th_tags_sortby_pcreleasedate3(inputs)
	if (locale === "ja") return ja_tags_sortby_pcreleasedate3(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_sortby_pcreleasedate3(inputs)
	if (locale === "zh-Hant") return zh_hant1_tags_sortby_pcreleasedate3(inputs)
	return ko_tags_sortby_pcreleasedate3(inputs)
});
export { tags_sortby_pcreleasedate3 as "tags.sortBy.pcReleaseDate" }